import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';

import { deleteProject } from 'services/api/project';
import { IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

export default function ProjectActivation(props) {
    const { project } = props;
    const navigate = useNavigate();
    const queryClient = useQueryClient();

    const delProject = async () => {
        const result = window.prompt('Lütfen silmek için onaylıyorum yazın');
        if (result === 'onaylıyorum') {
            deleteProject(project._id).then(() => {
                queryClient.invalidateQueries({ queryKey: ['fetchProjects', 'active'] });
                queryClient.invalidateQueries({ queryKey: ['fetchProjects', 'passive'] });
                navigate('../projects');
            });
        }
    };

    return (
        <IconButton aria-label="delete" onClick={() => delProject()} size="large">
            <DeleteIcon fontSize="large" />
        </IconButton>
    );
}
